import breakTo, { maxWidth } from "../../styles/tools/breakTo";
import { important } from "../../styles/tools/parsers";

export default ({ colors, images, spacings }) => ({
  header: {
    overflow: "hidden",
    width: "100%",
    height: spacings.header.height.default,
    marginBottom: "1.5rem",
    backgroundColor: colors.header.bg,
    [breakTo("medium")]: {
      height: spacings.header.height.medium,
    },
  },

  "header--whitelabel": {
    height: important(spacings.header.height.noHeader),
  },

  "header--centered": {
    height: important(spacings.header.height.noFlowbar),
  },

  logo: {
    width: spacings.header.logo.width,
    height: spacings.header.logo.height,
    float: "left",
    marginTop: "1.5rem",
    position: "absolute",
    left: "15%",
    [maxWidth("small")]: {
      left: "5%",
    },
    [maxWidth("medium")]: {
      left: "10%",
    }
  },

  "logo--whitelabel": {
    display: "none",
  },

  "logo--centered": {
    right: "0",
    // margin: spacings.header.logo.margin.centered,
    [breakTo("medium")]: {
      right: "0",
      // margin: spacings.header.logo.margin.centered
    },
  },

  "logo-link": {
    display: "block",

    width: "100%",

    textAlign: "center",
  },

  "logo-img": {
    maxWidth: spacings.header.logo.maxWidth,
    width: spacings.header.logo.width,
    height: spacings.header.logo.height,

    margin: spacings.header.logo.margin.img,

    backgroundImage: images.header,
    backgroundRepeat: "no-repeat",
    backgroundSize: spacings.header.logo.backgroundSize,
    backgroundPosition: spacings.header.logo.backgroundPosition,
    [maxWidth("small")]: {
      width: "7.5rem",
    },
  },

  children: {
    backgroundColor: colors.header.children.bg,
    paddingTop: spacings.header.children.paddingTop.default,
    marginTop: "75px",
    //marginTop: spacings.header.children.marginTop.default,
    paddingBottom: "2rem",
    [breakTo("medium")]: {
      padding: ".2rem 0",
      height: spacings.header.children.height.medium,
    },
  },
  "children--whitelabel": {
    marginTop: important(spacings.header.children.marginTop.noHeader),
  },
});



// WEBPACK FOOTER //
// ./components/header/styles.js